"use client";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { memo, ReactNode, useMemo } from "react";
import Icon from "@/components/ui/Icon";

type OrderCardHeader = {
  title?: string;
  description?: string | ReactNode;
  variant?: "success";
} & React.ComponentProps<"div">;

export const OrderCardHeader = ({
  className,
  title = "Thank you, your order is confirmed!",
  description,
  variant = "success",
}: OrderCardHeader) => {
  const statusIcon = useMemo(() => {
    switch (variant) {
      default:
        return (
          <Icon
            id="icon-check_20"
            width={41}
            height={41}
            className="text-green-500"
          />
        );
    }
  }, [variant]);

  return (
    <div className={cn("flex flex-col items-center gap-6", className)}>
      <span
        className={cn(
          "rounded-full bg-green-100 inline-flex items-center justify-center shrink-0 w-16 h-16"
        )}
      >
        {statusIcon}
      </span>
      <div className="grid grid-cols-1 gap-2 text-center md:gap-3">
        {!!title && (
          <Typography
            variant="titleMd"
            className="font-semibold lg:text-2xl lg:leading-[130%]"
            asChild
          >
            <h3>{title}</h3>
          </Typography>
        )}
        {!!description && (
          <Typography
            variant="titleMd"
            className="font-semibold lg:text-2xl lg:leading-[130%]"
            asChild
          >
            <p>{description}</p>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default memo(OrderCardHeader);
